<script setup lang="ts">
import { type V1GetOptions } from "@gasparigit/omnia-sdk";
import Memoweb from "~/components/icons/Memoweb.vue";
import { processError } from "~/lib/utils/errors";
import { defineSeo } from "~/lib/utils/seo";

const omniaSdk = useOmniaSdk();

const page = usePage();
const options = ref<V1GetOptions>({
  order_mode: "desc",
});

const { data: memowebs, refresh: refreshMemowebs } = useAsyncData(`all-memowebs`, async () => {
  try {
    return await omniaSdk.v1.memowebs.list({ pagination: "classic", page: page.value }, options.value);
  } catch (error) {
    processError(error);
  }
});


const { data: news, refresh: refreshNews } = useAsyncData("notizie", async () => {
  try {
    return await omniaSdk.v1.contents.list({}, "notizie", { pagination: "classic"});
  } catch (error) {
    processError(error);
  }
});

watch(options.value, () => {
  refreshMemowebs();
});

defineSeo({ title: "Memoweb" });
</script>

<template>
  <FrontBreadcrumHero :breadcrumbs="[{ title: 'Memoweb' }]" title="Memoweb" :search="false" :icon="Memoweb"></FrontBreadcrumHero>

  <div class="main-content mb-10">
    <FrontContentsList title="Memoweb" :icon="Memoweb" :link-config="{}" v-model:data="memowebs" v-model:page="page" @update:page="refreshMemowebs()" :show-areas="true">
      <template #side>
        <FrontRadioGroupCard base-key="order" v-model="options.order_mode"></FrontRadioGroupCard>
        <FrontSideCard title="Informazioni" subtitle="dal Memoweb" :icon="Memoweb" v-if="news?.data?.length" :cta-link="'/notizie'">
          <FrontContentItem
            :link-config="{}"
            :compact="true"
            :show-children="false"
            :content="content"
            :show-areas="false"
            v-for="content in news.data.slice(0,3)"
            :key="`notizie-${content.id}`"
          />
        </FrontSideCard>
      </template>
    </FrontContentsList>
  </div>
</template>
